import { Component } from '@angular/core';
import { TranslatePipe } from '@next/core-lib/i18n';

@Component({
    selector: 'app-footer',
    template: `
    <p class="footer text--italic text--gray">
      {{ 'BFP.UI.Footer' | translate }}
    </p>
    <span class="footer text--bold">
      {{ 'BFP.UI.Agrifirm_info' | translate }}
    </span>
  `,
    styles: `
    .footer {
      font-size: 12px;
      color: var(--text-secondary);
      margin-top: 12px;
    }

    .text--italic {
      font-style: italic;
    }
  `,
    imports: [TranslatePipe],
})
export class FooterComponent {}
